import { css } from "@emotion/react"
import styled from "@emotion/styled"
import Title from "components/Title"

const dynamicStyles = ({ theme, addQuotes, image }) => css`
  ${addQuotes &&
  `
    ${theme.breakpoints.between("md", "lg")} {
      text-indent: -18px;
    }

    ${theme.breakpoints.between("lg", "xl")} {
      text-indent: -30px;
    }

    ${theme.breakpoints.between("xl", "2xl")} {
      text-indent: -30px;
    }

    ${theme.breakpoints.up("2xl")} {
      text-indent: -38px;
    }
  `}

  ${image &&
  `
    max-width: 767px !important;
  `}
`

const HeroScrollCaseTitle = styled(Title)`
  ${({ theme }) => theme.breakpoints.down("md")} {
    max-width: 370px;
    line-height: 48px;
  }

  ${({ theme }) => theme.breakpoints.between("md", "xl")} {
    max-width: 510px;
  }

  ${({ theme }) => theme.breakpoints.between("xl", "2xl")} {
    max-width: 660px;
  }

  ${({ theme }) => theme.breakpoints.up("2xl")} {
    max-width: 820px;
  }

  margin: 0 0 16px 0;
  color: white;

  ${dynamicStyles}
`

export default HeroScrollCaseTitle
